import React from "react";
import { ReactComponent as WarningIcon } from "assets/images/info-icon.svg";
import "./offline-modal.scss";

const baseClass = "offline-modal";

export const OfflineModal = () => {
  return (
    <div className={baseClass}>
      <div className={`${baseClass}__backdrop`} />
      <div className={`${baseClass}__content`}>
        <WarningIcon className={`${baseClass}__icon`} />
        <h2 className={`${baseClass}__title`}>No Internet Connection</h2>
        <p className={`${baseClass}__message`}>
          You are currently offline. Please check your internet connection to
          continue using the app.
        </p>
      </div>
    </div>
  );
};
